import useMutationCall from "../../../hooks/useMutationCall";
import { useDisableEmployeeMutation } from "../employeesSlice";

const useDisableEmployee = () => {
  return useMutationCall(useDisableEmployeeMutation);
};

export default useDisableEmployee;
